import { LangCode, LanguageCode } from "../models";

export interface BrandInput {
  id?: number;

  // Required
  slug: string;

  // Main brand image
  image_url?: string;
  gradient_color_1: string;
  gradient_color_2: string;
  // Brand profile image
  brand_profile_image_url?: string;

  // // Desktop cover banner images
  // desktop_brand_cover_banner_url_en: string | null;
  // desktop_brand_cover_banner_url_ar: string | null;

  // // Mobile cover banner images
  // mobile_brand_cover_banner_url_en: string | null;
  // mobile_brand_cover_banner_url_ar: string | null;

  // // Desktop section banner images
  // desktop_section_banner_url_en: string | null;
  // desktop_section_banner_url_ar: string | null;

  // // Mobile section banner images
  // mobile_section_banner_url_en: string | null;
  // mobile_section_banner_url_ar: string | null;

  // Extra fields
  is_premium: boolean;
  position: number | null;

  brand_translations: BrandInfoInput[];
}

interface BrandInfoInput {
  language: LanguageCode;
  name: string;
  desktop_brand_cover_banner_url?: string | null;
  mobile_brand_cover_banner_url?: string | null;
  desktop_section_banner_url?: string | null;
  mobile_section_banner_url?: string | null;
  seo_title?: string;
  seo_keywords?: string;
  meta_description?: string;
}

type FilterCondition = [string, string, string];

interface Filters {
  and?: FilterCondition[];
}

export interface BrandSearchInput {
  page: number;
  limit: number;
  filters?: Filters;
}